module.exports = __webpack_public_path__ + "img/10.ce85f8e2.png";